import React from 'react';
import style from './uploadWarning.module.scss';
import WarningIcon from 'icons/warning';
import cx from 'classnames';

export default function UploadWarning() {
  return (
    <div className={style.uploadWarning}>
      <WarningIcon className={style.icon}></WarningIcon>
      <span className={cx(style.warning, 'adaptive-f20')}>
        Загрузка контента возможна только с компьютера
      </span>
    </div>
  );
}
